import React from "react";
import Loader from './Loader';
import Navbar from "./Navbar";
import Header from './Header';
import ErrorContainer from './container/ErrorContainer';
import Footer from './Footer';
import useFetchSchoolData from "../hooks/useFetchSchoolData";
import useSidebarToggle from "../hooks/useSidebarToggle";

const Error = () => {
    useFetchSchoolData();
    useSidebarToggle();

    return (
        <div>
            <Loader />
            <Navbar />
            <Header />
            <ErrorContainer />
            <Footer />
        </div>
    );
};

export default Error;
